import React, { Component } from 'react';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ReactJson from 'react-json-view';
import PlaceholderJson from '../../Component/PlaceholderJson';
import useAPIResReqStore from '../useAPIResReqStore';
import Grid from '@mui/material/Grid';
import useThemeStore, { resolveMode } from '../../../stores/useThemeStore';

class SetUpPlaceholders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkKey: false,
      error: false,
    };
  }

  handleReactJson = () => {
    const { responseData } = useAPIResReqStore.getState();
    const isDark = resolveMode(useThemeStore.getState().preference) === 'dark';
    if (responseData.json != '') {
      let jsonData = JSON.parse(responseData.json);
      const fg = isDark ? '255, 255, 255' : '1, 1, 1';
      const fg2 = isDark ? '255, 255, 255' : '0, 0, 0';

      return (
        <ReactJson
          src={jsonData ? jsonData : {}}
          collapsed="true"
          name="Data"
          displayDataTypes={false}
          style={{ fontFamily: 'Open Sans !important' }}
          theme={{
            base00: `rgba(${fg}, 0)`,
            base01: `rgba(${fg}, 0.1)`,
            base02: `rgba(${fg2}, 0.2)`,
            base03: `rgba(${fg}, 0.3)`,
            base04: `rgba(${fg2}, 0.4)`,
            base05: `rgba(${fg}, 0.5)`,
            base06: `rgba(${fg}, 0.6)`,
            base07: `rgba(${fg}, 0.7)`,
            base08: `rgba(${fg}, 0.8)`,
            base09: `rgba(${fg}, 0.8)`,
            base0A: `rgba(${fg}, 0.8)`,
            base0B: `rgba(${fg}, 0.8)`,
            base0C: `rgba(${fg}, 0.8)`,
            base0D: `rgba(${fg}, 0.8)`,
            base0E: `rgba(${fg}, 0.8)`,
            base0F: `rgba(${fg}, 0.8)`,
          }}
        />
      );
    }
  };

  render() {
    const { responseData, placeholderError } = useAPIResReqStore.getState();

    return (
      <Grid container className="textAlignLeft">
        <Grid item xs={12}>
          <span>Sample response received</span>
          <Grid item xs={12} className="json-webhook">
            {this.handleReactJson()}
          </Grid>
          <PlaceholderJson
            componentStore={useAPIResReqStore.getState()}
            stepStatus={this.props.stepStatus}
            handleKeyChanges={error => {
              this.setState({ error });
              this.props.handleKeyChanges(error);
            }}
            data={this.props.componentStore.getState().responseData}
            placeholderJson={responseData.samplePlaceholders}
          />
        </Grid>
        <Grid item xs={12} className="dialogContentRight">
          <Grid item xs={12}>
            <Button
              onClick={() => this.props.onChangeState(1, 1)}
              disabled={this.state.error || placeholderError.length > 0}
              className="btnSpace"
              variant={'outlined'}
            >
              {' '}
              Back
            </Button>
            <Button
              onClick={() => this.props.onChangeState(3, 3)}
              disabled={this.state.error || placeholderError.length > 0}
              variant={'contained'}
              color={'primary'}
            >
              {' '}
              Next
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default SetUpPlaceholders;
